'use strict';

var React = require('react');
var Border = require('../common/Border');
var TextParts = require('../common/TextParts');
var styleHelper = require('../../helper/styleHelper');

/**
 * 编号
 */
var CallOut = React.createClass({
  render: function () {
    var borderStyle = {
      borderRadius: 12,
      border : 'none',
      overflow:'hidden',
      position:'absolute'
    };

    var textStyle = {
      left: 8,
      top: 5,
      width: this.props.w - 8,
      height: this.props.h - 5,
      overflow:'hidden',

    };

    styleHelper.StyleUtil(this.props).default(borderStyle).size().background().text().align();
    return (<div style={borderStyle}>
      <TextParts {...this.props} partStyle={textStyle}/>
    </div>);
  }
});

module.exports = CallOut;



// WEBPACK FOOTER //
// ./src/views/Components/CallOut.jsx